import DialogView from '../../dialog/Dialog.view.tsx';
import { useTranslation } from 'react-i18next';
import styles from './ChangeOwnPassword.desktop.module.css';
import InputView from '../../../components/input/Input.view.tsx';
import LoaderView from '../../../components/loader/Loader.view.tsx';
import type ChangeOwnPasswordProperties from '../ChangeOwnPassword.properties.ts';
import { useChangeOwnPasswordController } from '../ChangeOwnPassword.controller.ts';

export default function ChangeOwnPasswordDesktopView(props: ChangeOwnPasswordProperties) {
  const { t } = useTranslation();
  const {
    loading,
    handleSave,
    enableSaveButton,
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    repeatPassword,
    setRepeatPassword,
  } = useChangeOwnPasswordController(props);

  return (
    <DialogView
      header={t('ui.changeOwnPasswordDialogHeader')}
      onBackdrop={props.handleDialogCloseClick}
    >
      <div>
        <>
          {loading && <LoaderView />}

          {!loading && (
            <>
              <table className={styles.table}>
                <tbody>
                  <tr>
                    <td className={styles.tdKey}>{t('ui.currentPassword')}</td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        type="password"
                        width={248}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tdKey}>{t('ui.newPassword')}</td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        type="password"
                        width={248}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tdKey}>{t('ui.repeatPassword')}</td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        type="password"
                        width={248}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className={styles.hint}>{t('ui.passwordMinLength')}</div>
              <div className={styles.buttonContainer}>
                <button
                  className={styles.buttonSave}
                  onClick={handleSave}
                  disabled={!enableSaveButton()}
                >
                  {t('ui.save')}
                </button>
              </div>
            </>
          )}
        </>
      </div>
    </DialogView>
  );
}
